'use strict';

const React = require('react');

function _interopNamespace(e) {
    if (e && e.__esModule) return e;
    const n = Object.create(null, { [Symbol.toStringTag]: { value: 'Module' } });
    if (e) {
        for (const k in e) {
            if (k !== 'default') {
                const d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: () => e[k]
                });
            }
        }
    }
    n.default = e;
    return Object.freeze(n);
}

const React__namespace = /*#__PURE__*/_interopNamespace(React);

const SvgMiscLearnFill = (props) => React__namespace.createElement(
  "svg",
  Object.assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", height: props.size, width: props.size }, props),
  React__namespace.createElement("path", { fill: "#2D2E2E", d: "M5 13.74V17.61l7 4.04 7-4.04v-3.87l-7 4.04-7-4.04Z" }),
  React__namespace.createElement("path", { fill: "#2D2E2E", d: "M12 3.35 1 9.7l11 6.35 7.92-4.58 1.08-.62V19h2V9.7L12 3.35Z" })
);

module.exports = SvgMiscLearnFill;
//# sourceMappingURL=MiscLearnFill.cjs.js.map
